import { createElementBlock as r, openBlock as n, createElementVNode as o, defineComponent as a, resolveComponent as p, createBlock as l } from "vue";
import s from "./InputIcon-DYMgHv8r.js";
import { _ as i } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function m(e, t) {
  return n(), r("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    o("path", { d: "M3 4a2 2 0 0 0-2 2v1.161l8.441 4.221a1.25 1.25 0 0 0 1.118 0L19 7.162V6a2 2 0 0 0-2-2H3Z" }),
    o("path", { d: "m19 8.839-7.77 3.885a2.75 2.75 0 0 1-2.46 0L1 8.839V14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.839Z" })
  ]);
}
const u = a({
  components: { InputIcon: s },
  setup: () => ({ EnvelopeIcon: m })
});
function d(e, t, _, f, I, h) {
  const c = p("InputIcon");
  return n(), l(c, {
    type: "email",
    icon: e.EnvelopeIcon
  }, null, 8, ["icon"]);
}
const E = /* @__PURE__ */ i(u, [["render", d]]);
export {
  E as default
};
//# sourceMappingURL=InputEmail-CSNxzrre.js.map
